"use client";
import { makeStyles, tokens, Button } from "@fluentui/react-components";
import { ArrowLeft20Regular } from "@fluentui/react-icons";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ClientRoutes } from "../models/ClientRoutes";
import ClearCacheButtonDialog from "../components/systemadmin/ClearCacheButtonDialog";
import RecacheNavigationButtonDialog from "../components/systemadmin/RecacheNavigationButtonDialog";
import { useGetUserAccessLevel } from "../hooks/useGetUserAccessLevel";

const useClasses = makeStyles({
  root: {
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    height: "100%",
    padding: tokens.spacingVerticalM,
    gap: tokens.spacingVerticalL,
  },
  header: {
    display: "flex",
    alignItems: "center",
    gap: tokens.spacingHorizontalM,
  },
  buttons: {
    display: "flex",
    flexDirection: "column",
    gap: tokens.spacingVerticalM,
  },
});

function CacheManagementPage() {
  const classes = useClasses();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const accessLevel = useGetUserAccessLevel();

  if (accessLevel > -1 && accessLevel < 5) {
    navigate("/");
  }

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <Button
          icon={<ArrowLeft20Regular />}
          appearance="subtle"
          onClick={() => navigate(ClientRoutes.SystemAdmin)}
        />
        <h2>{t("cacheManagement.title")}</h2>
      </div>
      <div className={classes.buttons}>
        <ClearCacheButtonDialog />
        <RecacheNavigationButtonDialog />
      </div>
    </div>
  );
}

export default CacheManagementPage;
